var _mask, _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourWaySingleLanes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "-100 -100 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    x: -100,
    y: -100,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#corner-fill"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#corner-fill",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#corner-fill",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#corner-fill",
    transform: "rotate(270)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "corner-fill",
    d: "      M -100 -25      L -30 -25      Q -25 -25 -25 -30      L -25 -100      L -100 -100",
    fill: "#000"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    x: -100,
    y: -100,
    fill: "#3a4149",
    mask: "url(#r)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourWaySingleLanes);
export default __webpack_public_path__ + "static/media/four-way-single-lanes.01349cf8124c09b2db4cf51ecccc9ef2.svg";
export { ForwardRef as ReactComponent };